import { Component, OnInit, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ProductService } from '../../../../../providers/services/product.service';
import { CartService } from '../../../../../providers/services/cart.service';
import { WishilistService } from '../../../../../providers/services/wishilist.service';
import { ProductBasicResponse } from '@pdp/common';
import { Category } from '../../../../../models/category';
import { ProductQuantity } from '../../../../../models/product-quantity';
import { Subject } from 'rxjs';
import { RequestUtils } from '@shop/app/common/request-utils';
import { NgIf, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pdp-item-two',
    templateUrl: './item-two.component.html',
    styleUrls: ['./item-two.component.scss'],
    imports: [NgIf, RouterLink, MatIcon, CurrencyPipe]
})
export class ItemTwoComponent implements OnInit {

  private unsubscribe: Subject<void> = new Subject();

  @Input()
  public product: ProductBasicResponse;

  @Input()
  public isFeatured;
  public routerLinkUrl: string;
  @Input()
  public category: Category;

  public productQuantity: ProductQuantity;
  public primaryImage: string;

  
  constructor(private router: Router, public productsService: ProductService, 
    private wishlistService: WishilistService, private cartService: CartService) { 
  }
  public handleError(event) {
    RequestUtils.logRequest('Error loading image', { event });
  }


  ngOnInit() {
    if (this.product) {
      if (this.product['image_url']) {
        // this.testImages(this.product['image_url'])
        //   .pipe(takeUntil(this.unsubscribe)).subscribe(testedPrimaryImage => {
        //     if ('no-image' === testedPrimaryImage) {
        //         this.primaryImage = 'assets/images/img-not-available.png';
        //     } else {
        //         this.primaryImage = testedPrimaryImage;
        //     }
        //   });
        this.primaryImage = this.product['image_url'];
      } else {
        this.primaryImage = 'assets/images/img-not-available.png';
      }
      this.productQuantity = this.productsService.computeQuantity(this.product['quantityAvailable'], this.product['salesAvailabilityType']);
      this.routerLinkUrl = this.isFeatured ? '/search/itm' + this.product['product_url'] : './itm' + this.product['product_url'];
    }
  }

  // public testImages(url: string): Observable<string> {
  //   const fullUrl  = environment.baseUrl + '/images/products/' + url;
  //   return Observable.create((observer: Observer<any>) => {
  //       const image = new Image();
  //       image.src = fullUrl;
  //       image.onload = () => observer.next(image.src);
  //       // image.onload = () => observer.next(url);
  //       image.onerror = () => observer.next('no-image');
  //   });
  // }


  ngOnChanges(value) {
  }
  

  public variantImage  :  any = ''; 
  public selectedItem  :  any = '';



  // Add to cart
  public addToCart(product: ProductBasicResponse,  quantity: number = 1) {
    // this.cartService.addToCart(product,quantity);
  }

  // Add to compare
  public addToCompare(product: ProductBasicResponse) {
    //  this.productsService.addToCompare(product);
  }

  // Add to wishlist
  public addToWishlist(product: ProductBasicResponse) {
    //  this.wishlistService.addToWishlist(product);
  }
 
 // Change variant images
  public changeVariantImage(image) {
     this.variantImage = image;
     this.selectedItem = image; 
  }  

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
}

}
